import { render } from "./DimensionQuestions.vue?vue&type=template&id=765e5292"
import script from "./DimensionQuestions.vue?vue&type=script&lang=js"
export * from "./DimensionQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__